import { create } from "zustand"

type ConfirmationVariant = "default" | "destructive" | "outline"

interface ConfirmationState {
  isOpen: boolean
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  variant: ConfirmationVariant
  isLoading: boolean
  onConfirm: () => Promise<void> | void

  // Actions
  open: (options: {
    title: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
    variant?: ConfirmationVariant
    onConfirm: () => Promise<void> | void
  }) => void
  close: () => void
  setLoading: (loading: boolean) => void
}

export const useConfirmationStore = create<ConfirmationState>((set) => ({
  isOpen: false,
  title: "",
  message: "",
  confirmLabel: "Confirm",
  cancelLabel: "Cancel",
  variant: "default",
  isLoading: false,
  onConfirm: async () => {},

  open: (options) =>
    set({
      isOpen: true,
      title: options.title,
      message: options.message,
      confirmLabel: options.confirmLabel || "Confirm",
      cancelLabel: options.cancelLabel || "Cancel",
      variant: options.variant || "default",
      onConfirm: options.onConfirm,
      isLoading: false,
    }),

  close: () =>
    set({
      isOpen: false,
      isLoading: false,
    }),

  setLoading: (loading) =>
    set({
      isLoading: loading,
    }),
}))
